var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 51,
    viewBox: "0 0 39 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4999 50.8334C22.1124 50.8334 24.2499 48.5084 24.2499 45.6667H14.7499C14.7499 48.5084 16.8636 50.8334 19.4999 50.8334ZM33.7499 35.3334V22.4167C33.7499 14.4859 29.8549 7.84671 23.0624 6.09004V4.33337C23.0624 2.18921 21.4711 0.458374 19.4999 0.458374C17.5286 0.458374 15.9374 2.18921 15.9374 4.33337V6.09004C9.12113 7.84671 5.24988 14.46 5.24988 22.4167V35.3334L0.499878 40.5V43.0834H38.4999V40.5L33.7499 35.3334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/Notifications.b2e0bfde3330e14b392785063ab64556.svg";
export { ForwardRef as ReactComponent };